// client/src/components/admin/influencer/InfluencerInfoList.js
import React, { useState, useEffect } from 'react';
import '../../../styles/admin/AdminTable.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const STATUS_BADGES = {
  approved: { label: '승인', className: 'admin-list__item-badge--success' },
  pending: { label: '대기', className: 'admin-list__item-badge--warning' },
  rejected: { label: '거절', className: 'admin-list__item-badge--danger' }
};

function InfluencerInfoList({ onSelect, selectedId, refreshToken, search, page, onPageChange, verifiedStatusFilter }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const pageSize = 20;

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, refreshToken, search, verifiedStatusFilter]);

  const fetchList = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page,
        pageSize,
        search: search || '',
        verifiedStatus: verifiedStatusFilter || 'approved'
      });

      const res = await fetch(`${API_URL}/api/admin/influencer/info/list?${params}`, {
        credentials: 'include'
      });
      const data = await res.json();

      if (data.ok) {
        setItems(data.items || []);
        setTotalPages(data.totalPages || 0);
      } else {
        setItems([]);
      }
    } catch (err) {
      console.error('fetchList error:', err);
      setItems([]);
    }
    setLoading(false);
  };

  return (
    <div className="admin-list">
      <div className="admin-list__header">인플루언서 목록</div>

      <div className="admin-list__body">
        {loading ? (
          <div className="admin-list__loading">불러오는 중...</div>
        ) : items.length === 0 ? (
          <div className="admin-list__empty">인플루언서가 없습니다.</div>
        ) : (
          <div>
            {items.map((item) => (
              <div
                key={item._id}
                onClick={() => onSelect(item)}
                className={`admin-list__item ${
                  selectedId === item.userId ? 'admin-list__item--selected' : ''
                }`}
              >
                <div className="admin-list__item-row">
                  <div className="admin-list__item-main">
                    {item.userId} <span className="admin-list__item-sub">({item.userName})</span>
                  </div>
                  {verifiedStatusFilter !== 'approved' && STATUS_BADGES[item.verifiedStatus] && (
                    <span className={`admin-list__item-badge ${STATUS_BADGES[item.verifiedStatus].className}`}>
                      {STATUS_BADGES[item.verifiedStatus].label}
                    </span>
                  )}
                </div>
                <div className="admin-list__item-meta" style={{ marginTop: '4px' }}>
                  가입: {new Date(item.registeredAt).toLocaleDateString('ko-KR')}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 페이지네이션 */}
      {totalPages > 1 && (
        <div className="admin-list__pagination">
          <div className="admin-list__pagination-info">
            {page} / {totalPages}
          </div>
          <div className="admin-list__pagination-buttons">
            <button
              onClick={() => onPageChange(p => Math.max(1, p - 1))}
              disabled={page === 1}
              className="admin-list__pagination-button"
            >
              ◀
            </button>
            <button
              onClick={() => onPageChange(p => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
              className="admin-list__pagination-button"
            >
              ▶
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default InfluencerInfoList;
